import { AccountQuotas } from './sub-models/account-quotas.model';
import { BannersCanvases } from './sub-models/banners-canvases.model';
import { CurrentPlan } from './sub-models/current-plan.model';
import { PurchaseInfo } from './sub-models/purchase-info.model';
import { Toggles } from './sub-models/toggles.model';
import { Map } from 'immutable';

export const UPDATE_FEATURE_FRAMEWORK_DATA_DELAY = 2000; // 2 seconds

export const RESOLVE_KEY = 'featuresData'; // key is the same as the RESOLVE in features-data.resolve.ts

export interface IFeaturesDataResolveData {
  accountQuotas: AccountQuotas;
  toggles: Toggles;
  purchaseInfo: PurchaseInfo;
  currentPlan: CurrentPlan;
  bannersCanvases: BannersCanvases;
  payloads: Map<string, any>;
}

export enum BannerCanvasTypesEnum {
  window = 'window',
  feature_lock = 'feature_lock',
  feature_highlight = 'feature_highlight',
  quota_reached = 'quota_reached',
}

export enum PayloadTypeEnum {
  save_items = 'save_items',
  mfa_reason = 'mfa_reason',
  verify_account = 'verify_account',
}

export enum VerifyAccountStateEnum {
  notify = 'notify',
  force = 'force',
  none = 'none',
}
